<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Comptes</v-toolbar-title>
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-data-table :headers="headers" :items="agencies" :items-per-page="20" class="elevation-0">
          <template v-slot:item="{item}">
            <tr>
              <td>{{item.name}}</td>
              <td>{{$format.money(item.availableFunds)}}</td>
              <td>{{item.numberUsers}}</td>
              <td>
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="view(item)">
                      <v-list-item-title>Voir</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: function() {
    return {
      headers: [
        { text: "Nom", value: "name" },
        { text: "Montant disponible", value: "availableFunds" },
        { text: "Nombre d'utilisateur", value: "numberUser" },
        { text: "Actions", value: "action", sortable: false }
      ],
      serviceForm: false,
      valid: false,
      service: {
        type_id: 0,
        name: "",
        status: 0
      }
    };
  },
  computed: {
    ...mapState("account", {
      agencies: state => state.list
    })
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    ...mapActions("account", ["getList"]),

    view(account) {
      this.$router.push("/account/view/" + account.id);
    }
  }
};
</script>

<style>
</style>